import React from 'react';
import { useOverviewDashboardStore } from 'pages/ReportsPage/components/AnalyticsDashboards/OverviewDashboard/store/overviewDashboard.store';
import { useChartColors } from 'pages/ReportsPage/components/AnalyticsDashboards/chartColors';
import {
  HorizontalBarChart,
  HorizontalBarItem,
} from 'pages/ReportsPage/components/AnalyticsDashboards/OverviewDashboard/HorizontalBarChart';
import { EmptyStateContainer } from 'pages/ReportsPage/components/AnalyticsDashboards/OverviewDashboard/OverviewDashboard.styled';
import { getFulfillmentBarColor } from 'pages/ReportsPage/components/AnalyticsDashboards/FulfillmentDashboard/FulfillmentDashboard.constants';
import { formatDashboardNumber } from 'pages/ReportsPage/components/AnalyticsDashboards/formatDashboardNumber';

export const FulfillmentByPositionChart: React.FC = () => {
  const data = useOverviewDashboardStore((s) => s.fulfillmentByPosition);
  const page = useOverviewDashboardStore((s) => s.fulfillmentByPositionPage);
  const totalPages = useOverviewDashboardStore((s) => s.fulfillmentByPositionTotalPages);
  const loadingMore = useOverviewDashboardStore((s) => s.fulfillmentByPositionLoadingMore);
  const loadMore = useOverviewDashboardStore((s) => s.loadMoreFulfillmentByPosition);
  const palette = useChartColors();

  if (!data || data.length === 0) {
    return (
      <EmptyStateContainer>
        No fulfillment data available for the selected filters.
      </EmptyStateContainer>
    );
  }

  const items: HorizontalBarItem[] = data.map((d) => {
    const color = getFulfillmentBarColor(
      d.fulfillmentPercentage,
      palette.chartColors,
      palette.threshold,
    );
    const percentage = formatDashboardNumber(d.fulfillmentPercentage);
    return {
      label: d.position,
      value: d.fulfillmentPercentage,
      valueLabel: `${percentage}% (${d.totalShifts} shifts)`,
      ariaLabel: `${d.position}: ${percentage}% (${d.totalShifts} shifts)`,
      tooltipHtml: `<strong>${d.position}</strong><br/>Fulfillment: ${percentage}%<br/>Shifts: ${d.totalShifts}`,
      barColor: color,
      valueLabelColor: color,
    };
  });

  return (
    <HorizontalBarChart
      items={items}
      maxValue={100}
      rightMargin={140}
      leftMargin={170}
      wrapLabels
      scrollable
      ariaLabel="Fulfillment by position chart showing fulfillment percentage per position"
      onLoadMore={loadMore}
      hasMore={page < totalPages}
      isLoadingMore={loadingMore}
    />
  );
};
